module.exports = __webpack_public_path__ + "static/media/Ramailo Holi8.3b9218ed.mp4";